export default __webpack_public_path__ + "static/Festl_Tour_Impressionen_5-87166c1720c52fb152375474a4b185d1.jpg";